import { Col } from "react-bootstrap";

export const ProjectCard = ({ title, description, imgUrl, pdfUrl }) => {

  const handleClick = (e) => {
    if (pdfUrl) {
      e.stopPropagation();
      window.open(pdfUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <Col size={12} sm={6} md={4}>
      <div className="proj-imgbx">
        <img src={imgUrl} alt={title || "Project"} />
        <div className="proj-txtx">
          <h4
            onClick={handleClick}
            style={{
              cursor: pdfUrl ? "pointer" : "default",
              textDecoration: pdfUrl ? "underline" : "none",
              color: "white",
            }}
          >
            {title}
          </h4>
          <span>{description}</span>
        </div>
      </div>
    </Col>
  );
};